<template>
  <router-view />
</template>
<script>
  export default {
    name: 'ProdutoModule',
  }
</script>
